import React, { useState } from 'react';
import { Modal, Input, message, Button, Form } from 'antd'; 
import { PlusOutlined } from '@ant-design/icons';
import CountryChooser from '../../components/CountryChooser/CountryChooser';
import useAddressCreate from '../../gql/hooks/useAddressCreate';
import './styles.less';

const ILTAddresesModal = ( { addedCallback } ) => {
    const [ addForm ] = Form.useForm();
    const { createAddress } = useAddressCreate();
    const [ showAddModal, setShowAddModal ] = useState( false );
    const [ modalIsSaving, setModalIsSaving ] = useState( false );
 
    const handleAddClick = () => {
        setShowAddModal( true );
    };

    const handleAddClose = () => {
        addForm.submit();
    };
    
    const handleAddCancel = () => {
        setShowAddModal( false );
        addForm.resetFields();
    };

    /*************************************
     *  ANCHOR Add Address
     *************************************/
 
    const handleAddAddressSubmit = async ( values ) => {
        setModalIsSaving( true );

        const response = await createAddress( { ...values } );

        if ( response.success ) { 
            addedCallback(  {   
                ...response.response.data.createAddress,
                key: response.response.data.createAddress.id 
            } );
        } else {
            message.error( 'Error creating address. Please try again later.' );
        }
        
        addForm.resetFields();
        setModalIsSaving( false );
        setShowAddModal( false );
    };
    
    return (
        <>
            <Button   
                style={ { marginTop: '4px' } }
                type="text"
                icon={ <PlusOutlined /> }
                onClick= { () => handleAddClick() }
            />

            { showAddModal && 
                <Modal
                    centered
                    width={ 800 }
                    title="Add Address"
                    open={ showAddModal }
                    onOk={ handleAddClose }
                    onCancel={ handleAddCancel } 
                    confirmLoading={ modalIsSaving }
                >
                    <Form
                        form={ addForm }
                        name="add-form"
                        layout="vertical"
                        onFinish={ handleAddAddressSubmit }
                        scrollToFirstError
                        disabled={ modalIsSaving }
                        initialValues={ 
                            { 
                                label: '',
                                name: '',
                                addressLine1: '',
                                addressLine2: '',
                                locality: '',
                                administrativeArea: '',
                                postalCode: '',
                                comment: '',
                                countryId: ''
                            }
                        }
                    >   
                        <Form.Item
                            name="label"
                            label="Label"
                            rules={ [
                                {
                                    required: true,
                                    validateTrigger: [],
                                    message: 'Label is required',
                                },
                                {
                                    max: 50,
                                    validateTrigger: [],
                                    message: 'Label must be less than 50 characters long.',
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            name="name"
                            label="Name"
                            rules={ [
                                {
                                    max: 100,
                                    validateTrigger: [],
                                    message: 'Name must be less than 100 characters long.',
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            name="addressLine1"
                            label="Address"
                            rules={ [
                                {
                                    required: true,
                                    validateTrigger: [],
                                    message: 'Address is required',
                                },
                                {
                                    max: 100,
                                    validateTrigger: [],
                                    message: 'Address must be less than 100 characters long.',
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            name="locality"
                            label="City/Locality"
                            rules={ [
                                {
                                    required: true,
                                    validateTrigger: [],
                                    message: 'City/Locality is required',
                                },
                                {
                                    max: 100,
                                    validateTrigger: [],
                                    message: 'City/Locality must be less than 100 characters long.',
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            name="administrativeArea"
                            label="State/Province"
                            rules={ [
                                {
                                    required: true,
                                    validateTrigger: [],
                                    message: 'State/Province is required',
                                },
                                {
                                    max: 100,
                                    validateTrigger: [],
                                    message: 'State/Province must be less than 100 characters long.',
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            name="postalCode"
                            label="Postal Code"
                            rules={ [
                                {
                                    required: true,
                                    validateTrigger: [],
                                    message: 'Postal Code is required',
                                },
                                {
                                    max: 50,
                                    validateTrigger: [],
                                    message: 'Postal code must be less than 500 characters long.',
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            name="countryId"
                            label="Country"
                            valuePropName="initialValue"
                            rules={ [
                                {
                                    required: true,
                                    validateTrigger: [],
                                    message: 'Country is required',
                                }
                            ] }
                        >
                            <CountryChooser />
                        </Form.Item>

                        <Form.Item
                            name="comment"
                            label="Comment"
                            rules={ [
                                {
                                    max: 100,
                                    validateTrigger: [],
                                    message: 'Comment must be less than 100 characters long.',
                                }
                            ] }
                        >
                            <Input/>
                        </Form.Item>                                
                    </Form>
                </Modal>
            }
        </>
    );
};

export default ILTAddresesModal;
